import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ScreenNotificationDefault} from '../../components';
import {redirectToFinish} from '../../ducks/Navigate';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

class LinkResendedSucess extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.LinkResendedSucess.title,
    );
  }

  render() {
    return (
      <ScreenNotificationDefault
        title={
          <p>
            Link reenviado <br /> com sucesso!
          </p>
        }
        content={
          <div>
            <p>Reenviamos o link para a assinatura no seu e-mail/SMS. </p>
            <small>Verifique sua caixa de SPAM.</small>
          </div>
        }
        textButton="Finalizar"
        actionButton={() => {
          this.props.redirectToFinish();
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  redirectToFinish,
})(LinkResendedSucess);
